import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import type { VatMode } from '@printdeal/product-selector';
import { Money } from '../../../../Money';

interface Props {
  centAmount?: number;
  currencyCode?: string;
  classNames: string;
  vatMode: VatMode;
  isStepByStep: boolean;
  isLoading: boolean;
}

export const PriceInfo = ({
  centAmount, currencyCode, classNames, vatMode, isStepByStep, isLoading,
}: Props) => (
  <div className="pd-flex pd-items-center pd-justify-end">
    <span data-cy="price" className={cx(classNames, { 'pd-font-bold': !isStepByStep })}>
      {!isLoading && centAmount ? (
        <Money
          value={centAmount}
          currency={currencyCode}
        />
      ) : (
        <span>-,--</span>
      )}
    </span>
    <span className={cx('pd-lowercase', classNames, { 'pd-font-bold': !isStepByStep })}>
      {vatMode === 'totalGross' ? (
        <FormattedMessage id="general.vat.inclusive" defaultMessage="incl. VAT" />
      ) : (
        <FormattedMessage id="general.vat.exclusive" defaultMessage="excl. VAT" />
      )}
    </span>
  </div>
);
